module.exports = __webpack_public_path__ + "static/img/store_logo.806c42b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/store_logo.svg
// module id = CLr9
// module chunks = 0